import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ICustomerInvoice } from '../interfaces/customer-invoice';
import { ICustomerInvoiceFilter } from '../interfaces/customer-invoice-filter';
import { ReadService } from './read.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class CustomerInvoiceService extends ReadService<ICustomerInvoice, ICustomerInvoiceFilter> {
  url = '/api/customerinvoices';
  entityTitle = 'Customer invoice';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getInvoiceTransaction(invoiceId: number): Promise<any[]> {
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getInvoiceTransactions?invoiceId=${invoiceId}`),
      this.handlersFactory.getForReadAll(),
    );
  }
}
